import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactFormPanelComponent } from './contact-form-panel.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RecaptchaModule } from "ng-recaptcha";

@NgModule({
  declarations: [
    ContactFormPanelComponent],
  exports: [
    ContactFormPanelComponent],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    RecaptchaModule
  ],
})
export class ContactFormPanelModule { }
